import {
  Button, Card, CardContent, CircularProgress, Container, Dialog,
  DialogActions, DialogContent, DialogContentText, DialogTitle, Grid, CardHeader, createTheme,
  Divider, TableCell, TableBody, TableRow, TableContainer, Paper, Table, TableHead,Select,FormControl
} from '@material-ui/core';
import React, { useState,useEffect } from 'react';
import Header from 'src/components/Header';
import Page from 'src/components/Page';
import axios from 'src/utils/axios';
import { getUser,sc,getDifferenceInDays } from 'src/utils/Common';
import { makeStyles, ThemeProvider } from '@material-ui/styles';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import trLocale from "date-fns/locale/tr";
import moment from 'moment';
import SearchIcon from '@material-ui/icons/Search';
import logger from 'src/utils/logger';


const useStyles = makeStyles((theme) => ({
  root: {
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3)
  },
  todos: {
    marginTop: theme.spacing(1)
  },
  contentMaterialImage: {
    padding: 5,
    minHeight: 580,
  },
  fields: {
    margin: theme.spacing(-1),
    display: 'flex',
    flexWrap: 'wrap',
    '& > *': {
      flexGrow: 1,
      margin: theme.spacing(1)
    }
  },
  submitMaterialImage: {
    marginTop: theme.spacing(2),
    width: '100%'
  },
}));

const materialTheme = createTheme({
  palette: {
    primary: {
      contrastText: '#FF9800',
      dark: '#424242',
      main: '#424242',
      light: '#424242'
    },
  },
});
const localeMap = {
  tr: trLocale,
};

function Nps() {
  const classes = useStyles();
  const [loading, setLoading] = useState(false);
  const [Uyari, setUyari] = React.useState("");
  const [ResponseData, setResponseData] = React.useState([]);
  const [open, setOpen] = React.useState(false);
  const today = moment(new Date()).format('YYYY-MM-DD');
  const [baslangicTarihi, setBaslangicTarihi] = React.useState(today);
  const [bitisTarihi, setBitisTarihi] = React.useState(today);
  const [TeknisyenValue, setTeknisyenValue] = React.useState("");
  const [TeknisyenData, setTeknisyenData] = React.useState([]);
  const [ResponseDataFull, setResponseDataFull] = React.useState([]);
  const SessionUser = getUser();
  const handleClose = () => {
    setOpen(false);
  };

  const handleDateChange = (event, type) => {
    var Deger = moment(event).format('YYYY-MM-DD');
    type === 1 ? setBaslangicTarihi(Deger) : setBitisTarihi(Deger);
  };
  const handleSearch = () => {
  
    if (getDifferenceInDays(new Date(baslangicTarihi), new Date(bitisTarihi)) > 30) {
      setUyari("İki tarih aralığı 30 günden büyük olamaz!...");
      setOpen(true);
      return
    }

    setLoading(true);
    axios.get('/GetArtemisNPS/' + SessionUser.ServiceShopId + '/' + baslangicTarihi + '/' + bitisTarihi + '/' + SessionUser.OrganizationUserId)
      .then(response => {
        const Data = response.data;
        if (Data.length === 0) {
          setResponseData([]);
          setResponseDataFull([]);
        } else {
          setResponseData(Data);
          setResponseDataFull(Data);
          var TeknisyenData1 = [];

          Data.forEach(item => {
            const kontrol = TeknisyenData1.filter(d => d.KUL_TEK_KODU === item.TEKNISYEN);
            if (kontrol.length === 0) {
              TeknisyenData1.push({ 'KUL_TEK_KODU': item.TEKNISYEN, 'TEKNISYEN': item.TEKNISYEN })
            }
          });
          setTeknisyenData(TeknisyenData1);
        }
        setLoading(false);
      }).catch(error => {
        setResponseData([]);
        setResponseDataFull([]);
        setLoading(false);
        logger.error("Hata detayı:", error.message);
      });
  }
  useEffect(() => {
    var todosData1 = [];
    todosData1 = ResponseDataFull.filter(function (item) {
      return (
        sc(item.TEKNISYEN, TeknisyenValue)
      );
    });
    setResponseData(todosData1);
    // eslint-disable-next-line
  }, [TeknisyenValue]);

  const handleChangeTeknisyen = (e) => {
    setResponseData([]);
    setTeknisyenValue(e.target.value);

  }


  return (
    <Page className={classes.root} title="Nps">
      <Container maxWidth="lg">
        <Header />
        <Card>
          <CardHeader title="Nps" />
          <Divider />
          <CardContent className={classes.contentMaterialImage}>
            {loading && <CircularProgress
              status={'loading'}
              style={{ marginLeft: '50%' }}
            />}
            <br />
            <Grid container spacing={1}>
              <Grid item xs={6} sm={6}>
                <ThemeProvider theme={materialTheme}>
                  <MuiPickersUtilsProvider utils={DateFnsUtils} locale={localeMap["tr"]}>
                    <KeyboardDatePicker
                      color="primary"
                      inputVariant="outlined"
                      label={'Başlangıç Tarihi'}
                      invalidDateMessage={'Hatalı Tarih Formatı'}
                      format={'dd.MM.yyyy'}
                      variant="outlined"
                      value={baslangicTarihi}
                      onChange={e => handleDateChange(e, 1)}
                      KeyboardButtonProps={{
                        'aria-label': 'change date',
                      }}
                    />
                  </MuiPickersUtilsProvider>
                </ThemeProvider>
              </Grid>
              <Grid item xs={6} sm={6}>
                <ThemeProvider theme={materialTheme}>
                  <MuiPickersUtilsProvider utils={DateFnsUtils} locale={localeMap["tr"]}>
                    <KeyboardDatePicker
                      color="primary"
                      inputVariant="outlined"
                      label={'Bitiş Tarihi'}
                      invalidDateMessage={'Hatalı Tarih Formatı'}
                      format={'dd.MM.yyyy'}
                      variant="outlined"
                      value={bitisTarihi}
                      onChange={e => handleDateChange(e, 2)}
                      KeyboardButtonProps={{
                        'aria-label': 'change date',
                      }}
                    />
                  </MuiPickersUtilsProvider>
                </ThemeProvider>
              </Grid>
              <Grid item xs={12} sm={12}>
                <Button
                  variant="contained"
                  color="secondary"
                  className={classes.submitMaterialImage}
                  onClick={() => handleSearch()}
                  endIcon={<SearchIcon />}>
                  Sorgula
                </Button>
              </Grid>
            </Grid>
            <br />
            <Divider />
            <br />
            <Grid item xs={12} sm={12}>
              <FormControl variant="outlined" fullWidth className={classes.formControl}>
                <Select
                  native
                  onChange={(e) => handleChangeTeknisyen(e)}
                  labelId="demo-simple-select-outlined-label"
                  id="demo-simple-select-outlined"
                  fullWidth
                  value={TeknisyenValue}> 
                  <option value="0" defaultValue="0">Teknisyen Seçiniz!...</option>
                {TeknisyenData.map(p => {
                  return <option key={p.KUL_TEK_KODU} value={p.KUL_TEK_KODU}>{p.TEKNISYEN}</option>
                })}
              </Select>
              </FormControl>
            </Grid>
            <br />
            <TableContainer component={Paper}>
              <Table className={classes.tableD} size="small" aria-label="a dense table">
                <TableHead>
                  <TableRow>
                    <TableCell>Servis</TableCell>
                    <TableCell>{ResponseData[0]?.SERVIS_PUAN ? (ResponseData[0]?.SERVIS_PUAN * 100).toFixed(2) : 0}%</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>Bölge Ortalama</TableCell>
                    <TableCell>{ResponseData[0]?.BOLGE_PUAN ? (ResponseData[0]?.BOLGE_PUAN * 100).toFixed(2) : 0}%</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>Türkiye Ortalama</TableCell>
                    <TableCell>{ResponseData[0]?.TURKIYE_PUAN ? (ResponseData[0]?.TURKIYE_PUAN * 100).toFixed(2) : 0}%</TableCell>
                  </TableRow>
                </TableHead>

              </Table>
            </TableContainer>
            <TableContainer component={Paper}>
              <Table className={classes.tableD} size="small" aria-label="a dense table">
                <TableHead>
                  <TableRow>
                    <TableCell>Teknisyen</TableCell>
                    <TableCell style={{ backgroundColor: '#00a500' }}>Olumlular</TableCell>
                    <TableCell style={{ backgroundColor: '#f95a61' }}>Olumsuzlar</TableCell>
                    <TableCell style={{ backgroundColor: '#fbec5d' }}>Kararsızlar</TableCell>
                    <TableCell style={{ backgroundColor: 'blue' }}>NpsAdet</TableCell>
                    <TableCell>Puan</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {ResponseData.map(row => (
                    <TableRow key={row.TEKNISYEN}>
                      <TableCell>{row.TEKNISYEN} </TableCell>
                      <TableCell>{row.OLUMLULAR}</TableCell>
                      <TableCell>{row.OLUMSUZLAR}</TableCell>
                      <TableCell>{row.KARARSIZ}</TableCell>
                      <TableCell>{row.NPS_ADET}</TableCell>
                      <TableCell>{row.PUAN * 100}%</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
                <TableBody>
                  <TableRow>
                    <TableCell align='right'><b>Toplam</b></TableCell>
                    <TableCell>{ResponseData[0]?.OLUMLU_TOPLAM}</TableCell>
                    <TableCell>{ResponseData[0]?.OLUMSUZ_TOPLAM}</TableCell>
                    <TableCell>{ResponseData[0]?.KARARSIZ_TOPLAM}</TableCell>
                    <TableCell>{ResponseData[0]?.DIP_TOPLAM}</TableCell>
                    <TableCell>{ResponseData[0]?.SERVIS_PUAN * 100}%</TableCell>
                  </TableRow>

                </TableBody>

              </Table>
            </TableContainer>
          </CardContent>
        </Card>
      </Container>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description" >
        <DialogTitle id="alert-dialog-slide-title" color="primary">{"Bilgilendirme"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            {Uyari}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Tamam
          </Button>
        </DialogActions>
      </Dialog>
    </Page>
  );
}

export default Nps;
